// app.ts
import { defineStore } from 'pinia'

const useAppStore = defineStore('app', {
  state: () => {
    return {
      watermarkEnabled: false,
      watermarkText: 'Ant Design Vue\nHappy Working', // 默认文字
      watermarkConfig: {
        fontSize: 16,
        color: 'rgba(100, 100, 100, 0.15)',
        rotate: -30,
        opacity: 0.6
      }
    }
  },
  actions: {
    setWatermarkEnabled (enabled: boolean) {
      this.watermarkEnabled = enabled
    },
    setWatermarkText (text: string) {
      this.watermarkText = text
    },
    setWatermarkConfig (config: Partial<typeof this.watermarkConfig>) {
      this.watermarkConfig = { ...this.watermarkConfig, ...config }
    },
    // 设置动态用户水印
    setUserWatermark (username: string) {
      if (username) {
        this.watermarkText = `${username}`
      } else if (username) {
        this.watermarkText = username
      }
    },
    // 切换水印开关
    toggleWatermark () {
      this.watermarkEnabled = !this.watermarkEnabled
    }
  },
  getters: {
    isWatermarkEnabled: (state) => state.watermarkEnabled
  }
})

export default useAppStore
